module.exports = __webpack_public_path__ + "img/happybrain_product1.ac45447f.jpg";